import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';
import { Company } from '@interfaces/common/company';
import { SharedModule } from '@shared/shared.module';
import { MenuItem } from 'primeng/api';
import { CompanySectorAssignModalComponent } from '@src/app/features/dashboard/company/company-list/components/modal/company-sector-assign-modal/company-sector-assign-modal.component';

/**
 * Ação em lote da listagem de empresas (card 3642): com empresas marcadas, mostra o menu flutuante "Trocar setor" e
 * abre a modal da troca. Só é montado para quem tem `COMPANYSECTOR_ASSIGN`.
 */
@Component({
  selector: 'app-company-sector-bulk-actions',
  imports: [SharedModule, CompanySectorAssignModalComponent],
  template: `
    @if (companies().length) {
      <app-floating-menu
        [items]="menuItems"
        [selectedCountMessage]="countMessage()"
        (clear)="cleared.emit()">
      </app-floating-menu>
    }
    <app-company-sector-assign-modal #assignModal (sectorAssigned)="assigned.emit()" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanySectorBulkActionsComponent {
  /** Empresas marcadas na tabela. */
  readonly companies = input<Company[]>([]);
  /** O X do menu flutuante: a listagem desmarca as linhas. */
  readonly cleared = output<void>();
  /** Setor gravado: a listagem recarrega e desmarca as linhas. */
  readonly assigned = output<void>();

  private readonly assignModal = viewChild<CompanySectorAssignModalComponent>('assignModal');

  protected readonly countMessage = computed(() => {
    const count = this.companies().length;
    return count === 1 ? '1 empresa selecionada' : `${count} empresas selecionadas`;
  });

  protected readonly menuItems: MenuItem[] = [
    {
      label: 'Trocar setor',
      icon: 'pi pi-tags',
      command: () => this.assignModal()?.open(this.companies()),
    },
  ];
}
